module.exports = __webpack_public_path__ + "img/EME_titlelogo_KB.2bef87b1.png";